import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getReguladoras = async () => {
    let reguladoras = null;
    try {
        const response = await api.get(`Reguladora/listcontroller`, config);
        reguladoras = response.data.data;
    } catch (err) {}
    return reguladoras;
}